import useLabLocalStorage from "../Labs/useLocalStorage";

const STORAGE_PREFIX = "media-clips:";

export default function useLocalStorage(key, fallback) {
  return useLabLocalStorage(STORAGE_PREFIX, key, fallback);
}
